import { Navigate } from "react-router-dom";

export default function ProtectedRoutes({ children, allowedRoles }) {
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/" replace />;
  }

  const role = localStorage.getItem("userrole");
  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to={["admin", "client", "support"].includes(role) ? `/${role}/dashboard` : "/"} replace />;
  }

  return children;
}
